module.exports = __webpack_public_path__ + "img/finance.8226ceab.svg";